import { useFormContext } from 'react-hook-form';
import { useContent } from 'src/contexts/ContentContext';
import { PosCurrencyField } from 'src/core/POS/PosCurrencyField';
import { ContentId } from 'src/utils/constants/contentId';
import {
  ListingGroupAutoPriceSettings,
  UiCurrency,
} from 'src/WebApiController';

import * as styles from './PricingSetting.css';

interface PricingSettingManualPriceRankPremiumSettingsProps {
  uiCurrency: UiCurrency;
}

export const PricingSettingManualPriceRankPremiumSettings = ({
  uiCurrency,
}: PricingSettingManualPriceRankPremiumSettingsProps) => {
  const setStartingPriceText = useContent(ContentId.SetStartingPrice);

  const { watch, setValue } = useFormContext<ListingGroupAutoPriceSettings>();

  const startingPrice = watch('startingUnitNetProceeds');

  const handleValueChange = (value: string) => {
    const numericValue = parseFloat(value);

    if (!isNaN(numericValue)) {
      setValue('startingUnitNetProceeds', numericValue);
    } else {
      setValue('startingUnitNetProceeds', null);
    }
  };

  return (
    <div className={styles.rankPremiumContainer}>
      <PosCurrencyField
        rootProps={{
          className: styles.manualRankPremiumValueInputWrapper,
        }}
        className={styles.textAlignRight}
        uiCurrency={uiCurrency}
        prefixDisplay={
          <span className={styles.setPriceText}>{setStartingPriceText}:</span>
        }
        value={startingPrice ?? undefined}
        onChange={(e) => {
          return handleValueChange(e.target.value);
        }}
      />
    </div>
  );
};
